import { jwtDecode } from "jwt-decode";

export const isTokenExpired = (token) =>    {
    if (!token) return true;

    try {
        const decoded = jwtDecode(token);
        return decoded.exp < Date.now() / 1000;
    } catch {
        return true;
    }
};